// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__op_zj","productName":"Table_productName__19Rwj"};